import {createContext} from "react";
import AuthContextType from "./AuthContextType";

/**
 * Method is not implemented.
 * @author Kacper Faber
 * @since 0.1.0
 */
const notImplemented = () => {
    throw new Error("Method's not implemented at this point. Probably you're using default value of context.");
}

/**
 * Default AuthContext value to use before initialization.
 * @author Kacper Faber
 * @since 0.1.0
 */
const defaults: AuthContextType = {
    user: undefined,
    login: notImplemented,
    logout: notImplemented
};

/**
 * Holds current user and methods to work with authentication.
 * @author Kacper Faber
 * @since 0.1.0
 */
const AuthContext = createContext<AuthContextType>(defaults);

// noinspection JSUnusedGlobalSymbols
export default AuthContext;